import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {ActionBarAction} from "../../navigation/action-bar/action-bar.component";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'vb-content-page-view',
  templateUrl: './content-page-view.component.html',
  styleUrls: ['./content-page-view.component.css']
})
export class ContentPageViewComponent implements OnInit, OnDestroy {

  @Input()
  touchMode: boolean = false;

  @Input()
  hideActions: boolean = false;

  @Input()
  actions: ActionBarAction[];

  @Input()
  isLoading: boolean;

  @Input()
  forceReInit: boolean = false;

  private initialized: boolean = true;

  constructor(private route: ActivatedRoute, private cd: ChangeDetectorRef) {
  }

  ngOnInit() {

    // Does not work:
    if (this.forceReInit) {
      this.initialized = false;
      this.cd.detectChanges();
      this.initialized = true;
      this.cd.detectChanges();
    }

    this.route.data.subscribe(d => {
      if (d.touchMode) {
        this.touchMode = d.touchMode;
      }
    });

  }

  ngOnDestroy(): void {
    this.initialized = false;
  }

  isContentVisible(): boolean {
    if (!this.forceReInit) {
      return true;
    } else {
      return this.initialized;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/components/content-page-view/content-page-view.component.ts